class ProductCategoriesPopups {
    constructor() {
        this.products = document.querySelectorAll('.products__item');
        if (this.products) {
            this.events();
        }
    }

    events() {
        this.products.forEach(product => {
            product.addEventListener('click', this.openPopup.bind(this, product));
        });

        document.addEventListener('keydown', (event) => {
            if (event.key == "Escape" && this.popupBg) {
                this.popupBg.classList.remove('opened');
            }
        });
    }

    openPopup(product, event) {
        this.popupBg = product.querySelector('.products__item-popup');
        this.popupClose = product.querySelector('.products__item-popup__close');
        
        if (!this.popupBg.classList.contains('opened')) {
            this.popupBg.classList.add('opened');
            this.popupClose.addEventListener('click', this.closePopup.bind(this, product));
            this.popupBg.addEventListener('click', this.handlePopupClick.bind(this, product));        }
        
        event.stopPropagation();
    }

    handlePopupClick(product, event) {
        if (event.target === this.popupBg) {
            this.closePopup(product, event);
        }
    }

    closePopup(product, event) {
        this.popupBg = product.querySelector('.products__item-popup');
        this.popupBg.classList.remove('opened');
        this.popupClose.removeEventListener('click', this.closePopup);
        this.popupBg.removeEventListener('click', this.closePopup);
        event.stopPropagation();
    }
}

export default ProductCategoriesPopups;
